
export default {
  apiHost: 'http://wallet-cn.liaoyantech.cn',
  wxShareConfig: {
    title: '全国机械通气雾化治疗调研', // 分享标题
    desc: '我们的调研分为“基本信息”和“机械通气雾化治疗技术”两个部分，请您根据顺序耐心填写，感谢您参与我们的调研。', // 分享描述
    link: 'http://client.rup-china.com/icu/wx/#/', // 分享链接
    imgurl: 'http://client.rup-china.com/icu/wx/icon.png', // 分享图标
  }
}



// WEBPACK FOOTER //
// ./src/common/config/index.js